import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { XmlFileFormatEnum } from '../../enums/xml-file-format.enum';
import { AsyncJob } from '../../models/async-job.model';
//import { Clipboard } from '@angular/cdk/clipboard';
//import { IHasIdAndName } from '../../interfaces/has-id-and-name.interface';
import { Form } from '../../models/form-builder/form.model';
import { AsyncJobService } from '../../services/async-job.service';
//import { CopySiteService } from '../../services/copy-site.service';
import { ExportDataService } from '../../services/export-data.service';
import { ExportAsyncJobDialogBase } from '../async-job-base/export-async-job-base.dialog';
import { ExportMetadataService } from '../../services/export-metadata.service';
import { ExportFormInstancesMetrics } from '../../models/export-import/export-form-instances-metrics.model';

@Component({
    selector: 'app-export-structure',
    templateUrl: './export-structure.dialog.html',
    styleUrls: [
        '../async-job-base/async-job-base.dialog.scss',
        './export-structure.dialog.scss'
    ],
    standalone: false
})
export class ExportStructureInstancesDialog extends ExportAsyncJobDialogBase implements OnInit {
    // Properties.
    @Input() xmlFileFormat: XmlFileFormatEnum = XmlFileFormatEnum.VERBOSE_FORMAT;
    @Input() exportFormDefinitionOnly: boolean = false;

    private exportFormInstancesMetrics: ExportFormInstancesMetrics = null;

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<ExportStructureInstancesDialog>,
        @Inject(MAT_DIALOG_DATA) public form: Form,
        //private copySiteService: CopySiteService,
        private exportDataService: ExportDataService,
        private exportMetadataService: ExportMetadataService,
        protected injectedAsyncJobService: AsyncJobService)
    {
        super(injectedAsyncJobService);

        dialogRef.disableClose = true; // Disable closing the dialogue when the user clicks on the page.

        return;
    }

    // Implement a base class's abstract method.
    public get ComponentClassName(): string {
        return 'ExportStructureInstancesDialog';
    }

    // Life cycle methods.
    public ngOnInit(): void {
        return;
    }

    // Accessor methods.
    public get Title(): string {
        return (this.exportFormDefinitionOnly ? 'Export Form Definition' : 'Export All Form Copies');
    }

    public get ExportStructureName(): string {
        return (this.form.name);
    }

    public get ExecutionSummaryText(): string {
        let summaryText: string = super.deriveExecutionSummaryText(this.exportFormInstancesMetrics);

        return (summaryText);
    }

    public get DownloadExportedSiteUrl(): string {
        return this.ExportedDataUrl;
    }

    // Handle dialogue action(s).
    public startStructureExport(): void {
        // Note:  this class presently only handles
        //        exporting data for form instances.
        //let formInstance: FormInstance = <FormInstance>this.structureToExport;

        // Initiate the export.
        if (this.exportFormDefinitionOnly) {
            //this.copySiteService.exportFormDefinition(this.form.id).then(asyncJob => {
            this.exportMetadataService.exportFormDefinition(this.form.id).then(asyncJob => {
                // Save the returned job key.
                this.startMonitoringJob(asyncJob, this.jobUpdatedArrowFunction);
            });
        } else {
            //this.copySiteService.exportFormInstances(this.form.id, this.xmlFileFormat).then(asyncJob => {
            this.exportDataService.exportFormInstances(this.form.id, this.xmlFileFormat).then(asyncJob => {
                // Save the returned job key.
                this.startMonitoringJob(asyncJob, this.jobUpdatedArrowFunction, this.jobUpdatedArrowFunction);
            });
        }

        return;
    }

    // Protected methods.

    // Private methods.
    private jobUpdatedArrowFunction = (asyncJob: AsyncJob): void => {
        // Ask the copy site service to download the
        // exported site(in a separate browser tab).
        if (asyncJob.status == AsyncJob.STATUS_COMPLETE) {
            if ((this.jobCompletedMessageText != null) && (this.jobCompletedMessageText.trim() != ''))
                this.exportFormInstancesMetrics = ExportAsyncJobDialogBase.parseExportFormInstancesMetrics(this.jobCompletedMessageText);

            let downloadFileName: string = (this.exportFormDefinitionOnly ? `form_${this.form.id}_definition.zip` : `form_${this.form.id}_data.zip`)
            this.ExportedDataUrl = this.exportDataService.getResultFileDownloadUrl(asyncJob, downloadFileName);
        } else if ((asyncJob.stdOut != null) && (asyncJob.stdOut.trim() != '')) {
            this.exportFormInstancesMetrics = ExportAsyncJobDialogBase.parseExportFormInstancesMetrics(asyncJob.stdOut);
        }

        return;
    }
}
